import {isLocalStorageSupported} from './localStorage.helper';

export const isIosPrivateMode = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const userAgent = window.navigator.userAgent.toLowerCase(),
    ios = /iphone|ipad/.test(userAgent);
    if (!ios) {
      return false;
    }
    return !isLocalStorageSupported();
};



// WEBPACK FOOTER //
// ./helpers/privateMode.helper.js